import { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/style.css";
import { ToastContainer } from "react-toastify";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import PrivateRoutes from "./components/PrivateRoute";
import OTPVerification from "./pages/OtpVerification";
import PricingPlans from "./pages/pricing/Pricing";
import { CommonContextProvider } from "./utils/context";
import DataInitializer from "./DataInitilizer";
import Home from "./pages/Home";
import About from "./pages/about/About";
import HomeLayout from "./components/HomeLayout";
import Features from "./pages/features";
import Contact from "./pages/Contact";
import TermsOfService from "./pages/TermOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import UserDataDeletionForm from "./components/UserDataDeletionForm";
import SessionExpiredModal from "./components/Modals/SessionExpiredModal";

function App() {
  const navigate = useNavigate();
  const [showSessionModal, setShowSessionModal] = useState(false);

  useEffect(() => {
    const PUBLIC_ROUTES = [
      "/",
      "/about",
      "/features",
      "/pricing",
      "/contact",
      "/terms-conditions",
      "/privacy-policy",
      "/signin",
      "/signup",
      "/otpverification",
      "/userdelete",
    ];

    const handleTokenExpiration = async (response) => {
      if (response.status !== 401) return;

      const currentPath = window.location.pathname;
      if (PUBLIC_ROUTES.includes(currentPath)) return;

      try {
        const errorData = await response.clone().json();
        if (errorData?.code === "token_not_valid") {
          localStorage.setItem("SESSION_EXPIRED", "true");
          setShowSessionModal(true);
        }
      } catch {}
    };

    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      if (!response.ok) {
        await handleTokenExpiration(response);
      }
      return response;
    };
  }, []);

  const handleConfirmLogout = () => {
    localStorage.clear();
    setShowSessionModal(false);
    navigate("/signin");
  };

  const handleCancelLogout = () => {
    setShowSessionModal(false);
  };

  return (
    <CommonContextProvider>
      <ToastContainer />

      <SessionExpiredModal
        show={showSessionModal}
        onCancel={handleCancelLogout}
        onConfirm={handleConfirmLogout}
      />

      <DataInitializer />

      <Routes>
        <Route element={<HomeLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<PricingPlans />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-conditions" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Route>

        <Route path="/signin" element={<Login />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/otpverification" element={<OTPVerification />} />
        <Route path="/userdelete" element={<UserDataDeletionForm />} />

        <Route element={<PrivateRoutes />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
        </Route>
      </Routes>
    </CommonContextProvider>
  );
}

export default App;
